// Required for dev hot reload
if (import.meta.hot) {

    import.meta.hot.accept(() => {
      console.log("HMR")
    });
}

import Resources from './components/resources-search';
document.addEventListener('DOMContentLoaded', Resources, false);